import React from 'react';
import { Services } from '../components/sections/Services';
import { TextileServicesSection } from '../components/sections/TextileServicesSection';
import { CarpetCleaningSection } from '../components/sections/CarpetCleaningSection';
import { LagoonSection } from '../components/sections/LagoonSection';

const ServicesPage = () => {
  return (
    <div className="pt-32 sm:pt-40" data-testid="services-page">
      <Services />
      <TextileServicesSection />
      <CarpetCleaningSection />
      <LagoonSection />
    </div>
  );
};

export default ServicesPage;
